import React, {useContext, useEffect, useState} from 'react';
import './PersonalAreaWishlistShare.scss';
import { useMutation } from "@apollo/react-hooks";
import {SHARE_WISHLIST} from '../PersonalAreaWishlist/wishlistQuery';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
import {usePopup} from "../../../context/PopupContext";


const PersonalAreaWishlistShare = () => {
    const [message, setMessage] = useState();
    const [emailList, setEmailList] = useState();
    const [shared, setShared] = useState(false);
    const [share] = useMutation(SHARE_WISHLIST);
    const { wishlistId } = useParams();
    const { showAddToCartPopupMessage } = usePopup();
    const { t } = useTranslation();

    const shareWishlist = () => {

        if(!message || !emailList) {
            showAddToCartPopupMessage("Please fill out all fields", 'error', 4000)
        }

        share({
            variables: {
                wishlistId,
                message,
                emailList: emailList.trim()
            }
        }).then((response) => {
            if(response && response.data && response.data.shareWishlist) {
                showAddToCartPopupMessage(response.data.shareWishlist, 'success', 4000)
                setShared(true)
            }
        }).catch((response) => {
            if(response.graphQLErrors) {
                response.graphQLErrors.forEach((gqlError) => {
                    showAddToCartPopupMessage(gqlError.message, 'error', 4000)
                })
                return;
            }

            showAddToCartPopupMessage(response.message, 'error', 4000)
        })
    }

    if(shared) {
        return (<div>
            <h1><T id="wishlist.shared"/></h1>
            <Link className="wishlist__link-text" to="/customer/account/wishlist">
                <T id="wishlist.back"/>
            </Link>
        </div>)
    }

    return (<div className="main">
        <h1 className="title"><T id="wishlist.sharing"/></h1>
        <div className="form">
            <span className="description"><T id="wishlist.data"/></span>
            <div className="field required">
                <label htmlFor="emails"><T id="wishlist.emails"/></label>
                <textarea value={emailList}
                          onChange={({target}) => setEmailList(target.value)}
                          cols="60"
                          rows="5"
                          id="emails"
                />
            </div>
            <div className="field required">
                <label htmlFor="message"><T id="wishlist.message"/></label>
                <textarea value={message}
                          onChange={({target}) => setMessage(target.value)}
                          cols="60"
                          rows="5"
                          id="message"
                />
            </div>
        </div>
        <div className="actions-toolbar">
            <div className="primary">
                <button className="btn" onClick={() => { shareWishlist() }}>
                    <span className="text"><T id="wishlist.share"/></span>
                </button>
            </div>
            <div className="secondary">
                <Link className="wishlist__link-text" to="/customer/account/wishlist">
                    <T id="wishlist.back"/>
                </Link>
            </div>
        </div>
    </div>);
}

export default PersonalAreaWishlistShare;